<template>
	<div class="containerMain">
		<title-bar :topTitle="true" topTitleText="Colegios"/>
		<title-bar v-if="school" :title="school.name"/>
		<div class="col inner" v-if="school && history && history.length > 0">
			<div class="col between innerRubric sd">
				<b-table responsive style="cursor: pointer;" class="category all" striped hover :items="history" :fields="tableFields" @row-clicked="onRowClick">
					<template slot="date" slot-scope="item">
						{{item.value ? getHumanDate(item.value) : ''}}
					</template>
					<template slot="title" slot-scope="item">
						{{item.value || 'Sin título'}}
					</template>
				</b-table>
			</div>
		</div>
		<div class="col inner" v-else>
			<spinner :isMiniSpinner="true"/>
		</div>
	</div>
</template>

<script>
import helpers from '@/helpers';
import mediator from '@/mediator';

export default {
	props: ['schoolId', 'synthesisTypeId'],
	mounted () {
		setTimeout(() => {
			mediator.showContent();
		}, 1000);
	},
	data () {
		return {
			tableFields: {
				date: {
					label: 'Fecha',
					sortable: true
				},
				type: {
					label: 'Tipo',
					sortable: true
				},
				title: {
					label: 'Título/Nombre',
					sortable: true
				},
				personName: {
					label: 'Coach',
					sortable: true
				}
			}
		};
	},
	watch: {
		async synthesisTypeId () {
			this.loadData();
		}
	},
	computed: {
		school () {
			if (!this.$store.state.admin.schools) return null;
			return this.$store.state.admin.schools.find((school) => (school.schoolId == this.schoolId));
		},
		history () {
			if (!this.$store.state.admin.schoolHistory) return null;
			return this.$store.state.admin.schoolHistory.map((history) => {
				if (history.data) {
					let type = typeof history.data;
					if (type !== 'object') history.data = JSON.parse(history.data);
				}
				if (this.synthesisTypeId == 6) {
					history.type = 'Evaluación';
					history.title = history.teacher ? this.getPersonFullName(history.teacher) : '';
					history.personName = history.person ? this.getPersonFullName(history.person) : '';
					history.date = history.answeredAt;
					history.schoolName = '';
				} else if (this.synthesisTypeId == 4) {
					history.type = 'Incidencia';
					history.personName = history.personCreated ? this.getPersonFullName(history.personCreated) : '';
					history.date = history.createdAt;
				} else if (this.synthesisTypeId == 2) {
					history.title = history.data.name;
					let trainingTalk = this.trainingTalk(history);
					if (!history.title) history.title = trainingTalk ? trainingTalk.title : '';
					if (history.data.formationType)	{
						history.type = history.data.formationType == 'forParents'
						|| history.data.formationType == 1 ? 'Plática para padres' : 'Capacitación';
					}
					else history.type = 'Formación';
					history.personName = history.coach ? this.getPersonFullName(history.coach) : '';
					history.schoolName = history.school ? history.school.name : '';
				} else {
					history.title = history.data && history.data.name ? history.data.name : '';
					history.type = history.synthesisType ? history.synthesisType.name : '';
					history.date = history.createdAt;
					history.personName = history.coach ? this.getPersonFullName(history.coach) : '';
				}
				return history;
			});
		}
	},
	methods: {
		async loadData () {
			this.$store.dispatch('hideContent');
			await mediator.coaching.getAdminSchools();
			await mediator.coaching.getAdminSchoolHistoryByTypeId(this.schoolId, this.synthesisTypeId);
			await this.$store.dispatch('activeMenu', this.$router.currentRoute.path);
			this.$store.dispatch('showContent');
		},
		getHumanDate (date) {
			return helpers.dateTime.getHumanDate(date);
		},
		getPersonFullName (person) {
			return helpers.persons.getPersonFullName(person);
		},
		onRowClick (item) {
			if (this.synthesisTypeId == 1) this.$router.push(`/coaching/admin/schools/${this.schoolId}/visit-closure/${item.id}`);
			if (this.synthesisTypeId == 2) this.$router.push(`/coaching/admin/schools/${this.schoolId}/training/${item.id}`);
			if (this.synthesisTypeId == 3) this.$router.push(`/coaching/admin/schools/${this.schoolId}/diagnostic/${item.id}`);
			if (this.synthesisTypeId == 4) this.$router.push(`/coaching/admin/schools/${this.schoolId}/issue/${item.id}`);
			if (this.synthesisTypeId == 5) this.$router.push(`/coaching/admin/indicator/${item.id}`);
			if (this.synthesisTypeId == 6) this.$router.push(`/coaching/admin/schools/${this.schoolId}/evaluation/${item.id}`);
		},
		trainingTalk (synthesis) {
			if (!synthesis.data.coachingTalkTypeId) return null;
			if (!this.$store.state.admin.trainingTalks) return null;
			return this.$store.state.admin.trainingTalks.find((talk) => {
				return talk.id == synthesis.data.coachingTalkTypeId;
			});
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/routes/admin/SchoolSyntheses.vue